import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = {
  class: "modal-title",
  id: "moveToFolderModalLabel"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { class: "modal-footer mr-0 pr-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_popup_modal = _resolveComponent("popup-modal")!

  return (_openBlock(), _createBlock(_component_popup_modal, { ref: "popup" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.title), 1),
        _createElementVNode("button", {
          type: "button",
          class: "close",
          "aria-label": "Close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx._cancel && _ctx._cancel(...args)))
        }, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createElementVNode("p", null, _toDisplayString(_ctx.message), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary mr-10",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx._cancel && _ctx._cancel(...args)))
        }, _toDisplayString(_ctx.cancelButton), 1),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-danger",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx._confirm && _ctx._confirm(...args)))
        }, _toDisplayString(_ctx.okButton), 1)
      ])
    ]),
    _: 1
  }, 512))
}